import React from 'react';
import styled from 'styled-components';
import { useAppcues } from 'hooks';
import icon from './icon.png';

const AppcuesLaunchpad: React.FC = () => {
  const Appcues = useAppcues();

  React.useEffect(() => {
    Appcues.loadLaunchpad('#my-launchpad', {
      icon,
    });
  }, []);

  return <StyledLaunchpad id="my-launchpad" />;
};

const StyledLaunchpad = styled.div`
  display: inline-block;
  margin-left: 15px;
  margin-right: -8px;
  .appcues-widget-icon > img {
    position: relative;
    top: 2px;
  }
`;

export default AppcuesLaunchpad;
